import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-gap-16"},[_c(VTextField,{attrs:{"value":_vm.gte,"dense":"","outlined":"","label":_vm.$t('From'),"hide-details":"auto"},on:{"input":_vm.emitGte}}),_c(VTextField,{attrs:{"value":_vm.lte,"dense":"","outlined":"","label":_vm.$t('To'),"hide-details":"auto"},on:{"input":_vm.emitLte}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }